import React from 'react';

import { Body, Section } from 'src/presentation/components/forms/Layout';
import { CampaignDetails, CampaignSectionRow, FormHeader } from './RecipientCollectionsLayout';
import capitalize from 'lodash/capitalize';
import KeyValueReadOnlyFields from 'src/presentation/components/pages/proactiveCommunications/components/KeyValueReadOnlyFields';
import { toDateTimeString } from 'src/presentation/components/pages/shared/utils/TimeUtils';

const RecipientCollectionDetails = ({ item, 'data-aid': dataAid }) => {
  const progressString = `${item.completedRecipients}/${item.totalRecipients}`;
  const createdAtString = toDateTimeString(item.createdAt);
  const startAtString = toDateTimeString(item.startAfter);
  let endBeforeString;
  const invalidTimestamp = '0001-01-01T00:00:00.000Z';
  if (item.endBefore !== invalidTimestamp) {
    endBeforeString = toDateTimeString(item.endBefore);
  }

  return (
    <>
      <FormHeader>View Details</FormHeader>

      <Body data-aid={`${dataAid}editor`}>
        <Section>
          <CampaignSectionRow>
            <CampaignDetails data-aid="section-campaign-details" attr="campaignDetails" label="Campaign Details">
              <KeyValueReadOnlyFields
                fields={{
                  'Recipients CSV': item.name,
                  Status: capitalize(item.status),
                  Progress: progressString,
                  'Created on': createdAtString,
                  'Start date and time': startAtString,
                  'End date and time': endBeforeString,
                }}
              />
            </CampaignDetails>
          </CampaignSectionRow>
        </Section>
      </Body>
    </>
  );
};

export default RecipientCollectionDetails;
